export const ARTICLE_LIST_REQUEST = "ARTICLE_LIST_REQUEST";
export const ARTICLE_LIST_SUCCESS = "ARTICLE_LIST_SUCCESS";
export const ARTICLE_LIST_FAIL = "ARTICLE_LIST_FAIL";

export const POPULAR_ARTICLE_LIST_REQUEST = "POPULAR_ARTICLE_LIST_REQUEST";
export const POPULAR_ARTICLE_LIST_SUCCESS = "POPULAR_ARTICLE_LIST_SUCCESS";
export const POPULAR_ARTICLE_LIST_FAIL = "POPULAR_ARTICLE_LIST_FAIL";
